import { useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export const AddShelvesDialog = ({ onDone }) => {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(5);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/shelves", { count: Number(count) });
      toast.success(t("success"));
      setOpen(false);
      onDone();
    } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><Button data-testid="add-shelves-btn"><Plus className="w-4 h-4" />{t("addShelves")}</Button></DialogTrigger>
      <DialogContent data-testid="add-shelves-dialog">
        <DialogHeader><DialogTitle>{t("addShelves")}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5"><Label>{t("count")}</Label>
            <Input type="number" min={1} max={200} data-testid="add-shelves-count" value={count} onChange={(e) => setCount(e.target.value)} required /></div>
          <DialogFooter><Button type="submit" data-testid="add-shelves-submit">{t("add")}</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
